module.exports = __webpack_public_path__ + "static/media/AppsAndSessionIconDark.e538991e.svg";